// QR customer-facing pages only (namespace: "qr"). Draft — review the Spanish.
const qr_es = {
  add: "Agregar",
  additional_info: "Información adicional",
  all: "Todo",
  amount: "Importe",
  basket: "Cesta",
  basket_empty: "¡Tu cesta está vacía!",
  calories: "Calorías",
  cancel: "Cancelar",
  cart: "Carrito",
  change_mode: "Cambiar modo",
  customer_name: "Nombre del cliente",
  done: "Listo",
  failed_to_load_order_history: "Error al cargar el historial de pedidos",
  failed_to_load_products: "Error al cargar los productos",
  home: "Inicio",
  how_would_you_like_to_order: "¿Cómo te gustaría pedir?",
  insufficient_quantity: "Cantidad insuficiente",
  items: "Artículos",
  menu: "Menú",
  no: "No",
  no_menu_data_found: "No se encontraron datos del menú",
  options: "Opciones",
  order_confirmed: "Pedido confirmado",
  order_id: "N.º de pedido",
  order_placed_successfully: "¡Tu pedido se ha realizado con éxito!",
  order_with_ai: "Pedir con IA",
  order_yourself: "Pedir tú mismo",
  out_of_stock: "Agotado",
  place_new_order: "Realizar nuevo pedido",
  place_order: "Realizar pedido",
  please_scan_valid_qr_code_or_try_again_later:
    "Escanea un código QR válido o inténtalo de nuevo más tarde.",
  search_product_name_here: "Buscar producto aquí",
  select_language: "Seleccionar idioma",
  select_options: "Seleccionar opciones",
  selected_item: "Artículo seleccionado",
  skip: "Omitir",
  something_went_wrong: "Algo salió mal",
  status: "Estado",
  subtotal: "Subtotal",
  successfully_added: "Agregado con éxito",
  taxes: "Impuestos",
  total: "Total",
  touch_screen: "Pantalla táctil",
  validate_customer_name_required: "El nombre del cliente es obligatorio.",
  validate_vehicle_color_required: "El color del vehículo es obligatorio.",
  validate_vehicle_number_required: "El número del vehículo es obligatorio.",
  vehicle_color: "Color del vehículo",
  vehicle_number: "Número del vehículo",
  view_details: "Ver detalles",
  voice_assistant: "Asistente de voz",
  voice_connection_error: "Error de conexión de voz. Inténtalo de nuevo.",
  voice_session_inactive:
    "El asistente de voz se apagó tras una pausa. Toca el micrófono para empezar de nuevo.",
  voice_session_time_limit:
    "El asistente de voz alcanzó su límite de tiempo. Toca el micrófono para empezar de nuevo.",
  warning_empty_basket:
    "¿Seguro que quieres eliminar estos productos de la cesta?",
  welcome_to: "Bienvenido a",
  yes: "Sí",
  your_order: "Tu pedido",

  // Voice assistant UI (options modal + floating button status) and footer.
  available_options: "Opciones disponibles",
  voice_options_instruction: "Di qué opciones quieres o di «ninguna» para omitir",
  voice_initializing: "Inicializando…",
  voice_tap_to_start: "Toca para empezar",
  voice_listening: "Escuchando… (toca para pausar)",
  voice_speaking: "Hablando… (toca para pausar)",
  voice_added_to_cart: "Agregado al carrito",
  voice_removed: "Eliminado",
  voice_order_placed: "¡Pedido realizado!",
  voice_active: "Activo (toca para pausar)",
  powered_by: "Con la tecnología de",
  voice_product_not_found:
    "Lo siento, no encontré «{{product}}» en nuestro menú.",
  voice_product_out_of_stock: "Lo siento, {{product}} está agotado.",
  voice_options_prompt:
    "¿Quieres alguna opción con {{product}}? Disponibles: {{options}}. Di «no» o «ninguna» para omitir, o indica las opciones que quieres.",
  voice_stock_limited:
    "Lo siento, solo quedan {{available}} {{product}} en stock.",
  voice_added_quantity_to_cart:
    "Se añadieron {{quantity}} {{product}}{{options}} a tu carrito.",
  voice_item_not_in_cart: "«{{product}}» no está en tu carrito.",
  voice_removed_quantity:
    "Se eliminaron {{quantity}} {{product}} de tu carrito.",
  voice_cart_contents: "Tu carrito contiene: {{items}}.",
  voice_with_options: " con {{options}}",
  voice_cart_empty_submit:
    "Tu carrito está vacío. Añade artículos antes de enviar el pedido.",
  voice_failed_to_place_order:
    "No se pudo realizar el pedido. Inténtalo de nuevo.",
  voice_order_error:
    "Ocurrió un error al realizar tu pedido. Inténtalo de nuevo.",
  our_store: "Nuestra tienda",
  currency_riyals: "riales saudíes",
  voice_order_success:
    "¡Tu pedido se ha realizado con éxito! Número de pedido: {{orderId}}. ¡Gracias por tu pedido!",
};

export default qr_es;
